import { z } from 'zod';

import { YardColumnConfigSchema } from './yard-column-config.schemas.js';
import { YARD_STAGES, YardStageSchema, type YardStage } from './yard-stages.js';
import { YardStandaloneCardSchema } from './yard-standalone-card.schemas.js';

export { YARD_STAGES, YardStageSchema, type YardStage };

const YardPresenceSharedFields = {
  placeId: z.uuid(),
  partyId: z.uuid(),
  customerRoleId: z.uuid().nullable(),
  customerVehicleId: z.uuid().nullable(),
  partyDisplayName: z.string(),
  vehiclePlate: z.string().nullable(),
  vehicleNickname: z.string().nullable(),
  containerLabel: z.string().nullable(),
  workbayName: z.string().nullable(),
  enteredAt: z.iso.datetime(),
  columnId: z.uuid(),
  serviceOrderDisplaySequence: z.number().int().nullable(),
  quoteDisplaySequence: z.number().int().nullable(),
  stepStatus: z.string().nullable(),
} as const;

export const YardPresenceAppointmentItemSchema = z.object({
  kind: z.literal('APPOINTMENT'),
  appointmentId: z.uuid(),
  receptionId: z.null(),
  serviceOrderId: z.null(),
  quoteId: z.null(),
  stage: z.literal('SCHEDULED'),
  ...YardPresenceSharedFields,
});

export const YardPresenceReceptionItemSchema = z.object({
  kind: z.literal('RECEPTION'),
  appointmentId: z.uuid().nullable(),
  receptionId: z.uuid(),
  serviceOrderId: z.uuid().nullable(),
  quoteId: z.uuid().nullable(),
  stage: YardStageSchema,
  ...YardPresenceSharedFields,
});

export const YardPresenceItemSchema = z.discriminatedUnion('kind', [
  YardPresenceAppointmentItemSchema,
  YardPresenceReceptionItemSchema,
]);
export type YardPresenceItem = z.infer<typeof YardPresenceItemSchema>;

export const YardPresenceResponseSchema = z.object({
  items: z.array(YardPresenceItemSchema),
  standaloneCards: z.array(YardStandaloneCardSchema),
  columns: z.array(YardColumnConfigSchema),
});
export type YardPresenceResponse = z.infer<typeof YardPresenceResponseSchema>;
